/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Energy unit of measure. Supported value is:
 * - kWh (Kilowatt hour)
 *
 */
export var EnergyUomEnum;
(function (EnergyUomEnum) {
    EnergyUomEnum["K_WH"] = "kWh";
})(EnergyUomEnum || (EnergyUomEnum = {}));
